import React from 'react';
import BYOKBilling from './billing/BYOKBilling';
import PAYGBilling from './billing/PAYGBilling';
import FixedSubscriptionBilling from './billing/FixedSubscriptionBilling';

const Billing = ({ userInfo, planType, subscriptions }) => {
  switch (planType) {
    // BYOK billing view disabled — former BYOK users now see Fixed Subscription.
    // case 'byok':
    //   return <BYOKBilling userInfo={userInfo} />;
    case 'sixth_credit':
      return <PAYGBilling userInfo={userInfo} />;
    default:
      return <FixedSubscriptionBilling userInfo={userInfo} subscriptions={subscriptions} />;
  }
};

export default Billing;
